var styles = {"box":"Button_box_pypf9_1","title":"Button_title_pypf9_26","icon-container":"Button_icon-container_pypf9_27","sm":"Button_sm_pypf9_47","isActiveRectFill":"Button_isActiveRectFill_pypf9_58","active-bg":"Button_active-bg_pypf9_64","active-shadow":"Button_active-shadow_pypf9_65"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
